import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectBalancingQuestIntro } from "../../../../balancingSelectors/selectBalancingQuestIntros";
import { selectIsQuestVisited } from "../../../../selectors/selectVisitedQuests";
import { QuestStateType } from "../../../../utils/network/generated/protoTypes";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionQuestInfoSelect } from "../actionQuestInfo";
import { TypeActionQuest } from "../list/actionQuests";
export var epicQuestSelect = function (action$, state$) {
    return action$.pipe(ofType(TypeActionQuest.Select), switchMap(function (action) {
        var state = state$.value;
        var selectedQuest = action.quest;
        var isSelectedQuestAlreadyVisited = true;
        if (selectBalancingQuestIntro(selectedQuest.id)) {
            isSelectedQuestAlreadyVisited = selectIsQuestVisited(selectedQuest.id);
        }
        state.questInfo.quest.forEach(function (val) {
            if (val.questId === selectedQuest.id && val.state !== QuestStateType.COMPLETE) {
                val.state = QuestStateType.OPEN;
            }
        });
        var actions = [];
        actions.push(actionQuestInfoSelect(selectedQuest));
        if (!isSelectedQuestAlreadyVisited) {
            actions.push(actionModalOpen(IdModal.QuestIntros));
        }
        return from(actions);
    }), retry());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/epics/epicQuestSelect.ts
// module id = 1968
// module chunks = 3